module.exports = __webpack_public_path__ + "img/room3.4f303dc8.gif";